// extracted by mini-css-extract-plugin
module.exports = {"list":"_3lxr1ikjA1yP3izWe1fNlx","item":"_1s2nmzjRF_JhHn9lly_vvq","chevron":"_2HUMjKb2Cyy5_mhBGkaAP-"};